var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.context.request.feature_flags.ff_redesign_rating &&
    !_vm.hideRating
    ? _c(_setup.RatingRow, {
        attrs: {
          solidity: _vm.rating,
          "reviews-count": _vm.reviewsCount,
          "reviews-href": _vm.reviewsHref,
          centered: "",
        },
      })
    : _setup.context.request.feature_flags.ff_redesign_rating && _vm.hideRating
    ? _c(
        "a",
        {
          staticClass:
            "text-body-2 primary--text text-decoration-none link-decoration-none text-no-wrap",
          attrs: {
            "data-qa": "analyses_lpu_card_reviews_link",
            href: _vm.reviewsHref,
          },
        },
        [_vm._v("\n  " + _vm._s(_setup.reviewsCountText) + "\n")]
      )
    : _c(
        "div",
        { staticClass: "d-flex align-center justify-center ga-3 flex-wrap" },
        [
          !_vm.hideRating
            ? _c(
                "a",
                {
                  staticClass:
                    "d-inline-flex align-center gc-1 py-1 px-2 rounded bg-gray-40 text-decoration-none",
                  attrs: {
                    href: _vm.reviewsHref,
                    "data-qa": "analyses_lpu_card_rating",
                  },
                },
                [
                  _c("span", {
                    staticClass:
                      "ui-icon-rating-star-filled ui-icon-fz-medium rating--text flex-shrink-0",
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-subtitle-2 text--text" }, [
                    _vm._v(
                      "\n      " + _vm._s(_setup.formattedRating) + "\n    "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass:
                "text-body-2 primary--text text-decoration-none text-no-wrap",
              attrs: {
                "data-qa": "analyses_lpu_card_reviews_link",
                href: _vm.reviewsHref,
              },
            },
            [_vm._v("\n    " + _vm._s(_setup.reviewsCountText) + "\n  ")]
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }